import {
  mallDetailsFragment,
  mallShippingMethodFragment
} from "@saleor/fragments/mall";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { MallDetails, MallDetailsVariables } from "./types/MallDetails";
import {
  MallShippingMethodActivityLogs,
  MallShippingMethodActivityLogsVariables
} from "./types/MallShippingMethodActivityLogs";
import { MallTableList, MallTableListVariables } from "./types/MallTableList";

const mallList = gql`
  ${pageInfoFragment}
  ${mallDetailsFragment}
  query MallTableList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: MallInput
    $status: SmopStatusEnum
    $sortBy: MallSortingInput
  ) {
    malls(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
      status: $status
      sortBy: $sortBy
    ) {
      edges {
        cursor
        node {
          ...MallDetailsFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useMallListQuery = makeQuery<
  MallTableList,
  MallTableListVariables
>(mallList);

export const mallDetails = gql`
  ${mallShippingMethodFragment}
  ${mallDetailsFragment}
  query MallDetails($id: ID!) {
    mall(id: $id) {
      ...MallDetailsFragment
      mallShippingMethod {
        ...MallShippingMethodFragment
      }
    }
  }
`;
export const useMallDetailsQuery = makeQuery<MallDetails, MallDetailsVariables>(
  mallDetails
);

export const mallShippingMethodActivityLogs = gql`
  query MallShippingMethodActivityLogs(
    $first: Int
    $before: String
    $after: String
    $last: Int
    $subject: String
    $search: String
    $sortBy: ActivityLogSortingInput
  ) {
    mallShippingMethodActivityLogs(
      first: $first
      before: $before
      after: $after
      last: $last
      filter: { subject: $subject, search: $search }
      sortBy: $sortBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          message
          doer {
            id
            firstName
            lastName
            email
          }
          createdAt
        }
      }
    }
  }
`;
export const useMallShippingMethodActivityLogs = makeQuery<
  MallShippingMethodActivityLogs,
  MallShippingMethodActivityLogsVariables
>(mallShippingMethodActivityLogs);
